<app-view-state-container class="height100p flex-col" [state]="viewState">
    <ng-template #content>
        <sm-toolbar>
            <button pButton icon="fas fa-save" label="Speichern" [disabled]="!isChanged()" (click)="save()">
            </button>
            <p-checkbox class="ml-3" appLabel="Kompaktansicht" [(ngModel)]="compact" [binary]=true (ngModelChange)="fillTable()"></p-checkbox>
        </sm-toolbar>
        <sm-tab-view class="flex-item-fill full-height" [(value)]="activeTabIndex" (valueChange)="activeTabChanged()">
            <sm-tab value="0" header="Übersicht">        
                <sm-table class="height100p" [compact]=true [data]="table" [headerHeight]="100" [tabForSameCol]=true [horizontalScroll]="!compact" (onCellClicked)="cellClicked($event)" (onCellValueChanged)="valueChanged($event)">
                </sm-table>
            </sm-tab>
            <sm-tab value="1" header="Historie">
                @if (historyTable != null) {
                <sm-table class="height100p" [data]="historyTable"></sm-table>
                }
            </sm-tab>
        </sm-tab-view>
    </ng-template>
</app-view-state-container>